import type { ChecklistItem, CompanyProfile } from '../../data/regulations/types'

const KEY = 'ecopshub.regnav.v1'

export type NavigatorSession = {
  profile: CompanyProfile
  items: ChecklistItem[]
  hiddenIds: string[]
  completedIds: string[]
  generatedAt: string
}

export function loadSession(): NavigatorSession | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as NavigatorSession
    if (!parsed?.profile || !Array.isArray(parsed.items)) return null
    return parsed
  } catch {
    return null
  }
}

export function saveSession(session: NavigatorSession): void {
  sessionStorage.setItem(KEY, JSON.stringify(session))
}

export function clearSession(): void {
  sessionStorage.removeItem(KEY)
}
